import axios from 'axios'
import uuid from 'uuid'

import pathIntranet from '../ruta'

let csrf_token = null
let logout_token = null

export const savePdf = ({
  blobPdf,
  resolveD,
  resolveM,
  mail,
  idUsuario,
  idProyecto,
  idioma
}) => {
  const reject = error => {
    console.log(error)
  }

  const reject1 = error => {
    logout(null, e => console.log(e))
    console.log(error)
  }

  const resolveDownload = ({ url }) => {
    resolveD(url)
    logout(null, e => console.log(e))
  }

  const sendMail = fid => {
    return idUsuario => {
      axios({
        url: `${pathIntranet}/administracion/larcrea-mail?type=configuraciones&usuario=${idUsuario}&proyecto=${idProyecto}&idioma=${idioma}&pdf=${fid}`,
        method: 'GET',
        headers: {
          'X-CSRF-Token': csrf_token
        }
      })
        .then(response1 => {
          resolveM()
          logout(null, e => console.log(e))
        })
        .catch(error => {
          resolveM()
          logout(null, e => console.log(e))
        })
    }
  }

  const resolveMail = ({ fid }) => {
    axios({
      method: 'get',
      url: `${pathIntranet}/administracion/node/${idUsuario}?_format=json`,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf_token
      }
    })
      .then(function(response) {
        const pdfs = response.data.field_pdf
        pdfs.push({ target_id: fid })

        console.log(pdfs)

        const data = {
          type: [{ target_id: 'usuario' }],
          field_pdf: pdfs
        }

        updateNode(idUsuario, data, sendMail(fid), reject)
      })
      .catch(function(error) {
        resolveM()
        logout(null, e => console.log(e))
      })
  }

  if (blobPdf) {
    login(() => {
      createFile(
        blobPdf,
        `${uuid.v4()}.pdf`,
        mail ? resolveMail : resolveDownload,
        reject1
      )
    }, resolveM)
  }
}

const checkPlain = str => {
  str = str
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
  return str
}

export const createUser = (
  idProyecto,
  idioma,
  email,
  name,
  movil,
  cp,
  configuracion,
  setResponse
) => {
  const reject = error => {
    logout(null, setResponse)
    console.log(error)
    setResponse('error')
  }

  const resolve = nid => {
    logout(null, setResponse)
    setResponse(nid)
  }

  const sendMail = tipo => {
    return idUsuario => {
      axios({
        url: `${pathIntranet}/administracion/larcrea-mail?type=${tipo}&usuario=${idUsuario}&proyecto=${idProyecto}&idioma=${idioma}`,
        method: 'GET',
        headers: {
          'X-CSRF-Token': csrf_token
        }
      })
        .then(response1 => {
          resolve(idUsuario)
        })
        .catch(reject)
    }
  }

  login(() => {
    saveConfiguracion(configuracion)
      .then(values => {
        const data1 = {
          title: [{ value: checkPlain(email) }],
          type: [{ target_id: 'usuario' }],
          field_proyecto: [{ target_id: idProyecto }]
          //field_fecha: [{ value: getFecha() }]
        }

        data1.field_configuraciones =
          values.length > 0
            ? values.map(value => ({
                target_id: value.nid
              }))
            : []

        if (name !== null) {
          data1.field_nombre = [{ value: name }]
        }

        if (movil !== null) {
          data1.field_movil = [{ value: movil }]
        }

        if (cp !== null) {
          data1.field_codigo_postal = [{ value: cp }]
        }

        axios({
          method: 'get',
          url: `${pathIntranet}/administracion/usuario-existe?_format=json&email=${email}&proyecto=${idProyecto}`,
          auth: {
            username: 'leeestancias1',
            password: 'ed3ok5Rd$2fkDdc'
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function(response) {
            if (response.data.length > 0) {
              if (response.data[0].configuraciones !== '') {
                const configuraciones = response.data[0].configuraciones
                  .split(',')
                  .map(value => ({ target_id: value }))
                data1.field_configuraciones = configuraciones.concat(
                  data1.field_configuraciones
                )
              }

              return updateNode(
                response.data[0].nid,
                data1,
                sendMail('login'),
                reject
              )
            } else {
              console.log(data1)
              return createNode(data1, sendMail('registro'), reject)
            }
          })
          .catch(function(error) {
            reject(error)
          })
      })
      .catch(function(error) {
        reject(error)
      })
  }, setResponse)
}

export const identificateUser = (idProyecto, idioma, email, setResponse) => {
  const reject1 = error => {
    logout(null, setResponse)
    console.log(error)
    setResponse('error')
  }

  const resolve = nid => {
    logout(null, setResponse)
    setResponse(nid)
  }

  login(() => {
    axios({
      method: 'get',
      url: `${pathIntranet}/administracion/usuario-existe?_format=json&email=${email}&proyecto=${idProyecto}`,
      auth: {
        username: 'leeestancias1',
        password: 'ed3ok5Rd$2fkDdc'
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (response.data.length > 0) {
          axios({
            url: `${pathIntranet}/administracion/larcrea-mail?type=login&usuario=${
              response.data[0].nid
            }&proyecto=${idProyecto}&idioma=${idioma}`,
            method: 'GET',
            headers: {
              'X-CSRF-Token': csrf_token
            }
          })
            .then(response1 => {
              resolve(response.data[0].nid)
            })
            .catch(reject1)
        } else {
          logout(null, setResponse)
          setResponse('noUser')
        }
      })
      .catch(reject1)
  }, setResponse)
}

export const login = (resolve, reject) => {
  axios({
    method: 'post',
    url: `${pathIntranet}/administracion/user/login?_format=json`,
    data: {
      name: 'leeestancias1',
      pass: 'ed3ok5Rd$2fkDdc'
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(function(response) {
      csrf_token = response.data.csrf_token
      logout_token = response.data.logout_token

      if (resolve) {
        resolve()
      }
    })
    .catch(function(error) {
      axios({
        method: 'get',
        url: `${pathIntranet}/administracion/session/token`,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          csrf_token = response.data

          if (resolve) {
            resolve()
          }
        })
        .catch(error => {
          if (reject) {
            reject(error)
          }
        })
    })
}

export const logout = reject => {
  axios({
    method: 'post',
    url: `${pathIntranet}/administracion/user/logout?_format=json&token=${logout_token}`,
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(function(response2) {
      csrf_token = null
      logout_token = null
    })
    .catch(function(error) {
      csrf_token = null
      logout_token = null

      console.log('error')
    })
}

export const createNode = (data, resolve, reject) => {
  axios({
    method: 'post',
    url: `${pathIntranet}/administracion/node?_format=json`,
    data,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf_token
    }
  })
    .then(function(response) {
      resolve(response.data.nid[0].value)
    })
    .catch(function(error) {
      reject(error)
    })
}

export const createFile = (blob, filename, resolve, reject) => {
  fetch(URL.createObjectURL(blob)).then(res => {
    res.arrayBuffer().then(arrayBuffer => {
      axios({
        method: 'post',
        url: `${pathIntranet}/administracion/file/upload/node/usuario/field_pdf?_format=json`,
        data: arrayBuffer,
        headers: {
          'Content-Type': 'application/octet-stream',
          'Content-Disposition': `file; filename="${filename}"`,
          'X-CSRF-Token': csrf_token
        }
      })
        .then(function(response) {
          resolve({
            fid: response.data.fid[0].value,
            url: response.data.uri[0].url
          })
        })
        .catch(function(error) {
          reject(error)
        })
    })
  })
}

export const updateNode = (nid, data, resolve, reject) => {
  axios({
    method: 'patch',
    url: `${pathIntranet}/administracion/node/${nid}?_format=json`,
    data,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf_token
    }
  })
    .then(function(response) {
      resolve(response.data.nid[0].value)
    })
    .catch(function(error) {
      reject(error)
    })
}

const cloneConfiguraciones = configuraciones => {
  return configuraciones.map(configuracion => {
    const estancias = configuracion.estancias.map(estancia => {
      const acabados = estancia.acabados.map(acabado => {
        const opciones = acabado.opciones.map(opcion => opcion.id)

        return {
          id: acabado.id,
          opciones
        }
      })

      return {
        id: estancia.id,
        acabados
      }
    })
    return {
      id: configuracion.id,
      estancias
    }
  })
}

export const salvarConfiguracion = (
  idUsuario,
  configuracion,
  configuracionesActuales,
  setConfiguraciones
) => {
  const reject = error => {
    console.log(error)
  }

  const reject1 = error => {
    logout(null, reject)
    reject(error)
  }

  login(() => {
    saveConfiguracion(configuracion)
      .then(response => {
        const resolve = () => {
          logout(null, reject)

          const conf = cloneConfiguraciones(configuracionesActuales)

          conf.push({
            id: response.nid,
            estancias: configuracion
          })

          setConfiguraciones(conf)
        }

        const conf = configuracionesActuales.map(
          configuracion => configuracion.id
        )
        conf.push(response.nid)

        const data = {
          type: [{ target_id: 'usuario' }],
          field_configuraciones: conf.map(value => ({
            target_id: value
          }))
        }

        updateNode(idUsuario, data, resolve, reject1)
      })
      .catch(reject1)
  }, reject)
}

export const eliminarConfiguracion = (
  idUsuario,
  nid,
  configuracionesActuales,
  setConfiguraciones
) => {
  const reject = error => {
    console.log(error)
  }

  const reject1 = error => {
    logout(null, reject)
    reject(error)
  }

  const resolve = () => {
    axios({
      method: 'delete',
      url: `${pathIntranet}/administracion/node/${nid}?_format=json`,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf_token
      }
    })
      .then(function(response) {
        const conf = cloneConfiguraciones(configuracionesActuales)

        const conf1 = []
        conf.forEach(c => {
          if (nid !== c.id) {
            conf1.push(c)
          }
        })

        setConfiguraciones(conf1)
        logout(null, reject)
      })
      .catch(function(error) {
        reject1(error)
      })
  }

  const nids = configuracionesActuales.map(configuracion => configuracion.id)

  const index = nids.indexOf(nid)
  if (index > -1) {
    nids.splice(index, 1)
  }

  const data = {
    type: [{ target_id: 'usuario' }],
    field_configuraciones: nids.map(value => ({
      target_id: value
    }))
  }

  login(() => {
    updateNode(idUsuario, data, resolve, reject1)
  }, reject)
}

export const saveConfiguracion = configuracion => {
  const data = {
    title: [{ value: 'aaa' }],
    type: [{ target_id: 'configuracion_guardada' }],
    field_configuracion: [{ value: JSON.stringify(configuracion) }]
  }

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${pathIntranet}/administracion/node?_format=json`,
      data,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf_token
      }
    })
      .then(function(response) {
        resolve({
          nid: response.data.nid[0].value
        })
      })
      .catch(function(error) {
        reject(error)
      })
  })
}
